import type { TemplateRef } from '@angular/core';
import { Injectable } from '@angular/core';

@Injectable()
export class NestedTemplatesHistoryService<T = TemplateRef<any>> {
  private templatesHistoryState: T[] = [];
  private position = 0;

  public pushState(template: T): T {
    this.position++;

    this.templatesHistoryState = [
      ...this.templatesHistoryState.slice(0, this.position - 1),
      template,
    ];

    return this.lastTemplate;
  }

  public back(): T {
    if (!this.position) return this.templatesHistoryState[0];
    this.position--;

    return this.lastTemplate;
  }

  public clear() {
    this.templatesHistoryState = [];
    this.position = 0;
  }

  public ngOnDestroy(): void {
    this.templatesHistoryState = [];
  }

  private get lastTemplate() {
    return this.templatesHistoryState[this.position - 1];
  }
}
